import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { interpretRegisterError, registerAccount } from '../../utils/organisationApi';

const RegisterFromLink = () => {
  const location = useLocation();
  const [status, setStatus] = useState('waiting');
  const [message, setMessage] = useState('Please wait ...');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email');
    const first_name = params.get('first_name');
    const last_name = params.get('last_name');

    if (!email || !first_name || !last_name) {
      setStatus('error');
      setMessage('Missing required registration parameters.');
      return;
    }

    const registerUser = async () => {
      setStatus('waiting');
      setMessage('Please wait ...');
      try {
        const result = await registerAccount({ email, first_name, last_name });
        if (result.httpStatus === 202 || result.status === 'join_requested') {
          setStatus('success');
          setMessage(result.msg || 'Your request to join has been sent to its admins.');
        } else if (result.httpStatus === 201 || result.httpStatus === 200) {
          setStatus('success');
          setMessage(result.msg || 'User created successfully and Email sent');
        } else {
          setStatus('error');
          setMessage(result.msg || 'Registration failed.');
        }
      } catch (error) {
        setStatus('error');
        setMessage(interpretRegisterError(error).message || 'Registration failed.');
      }
    };
    registerUser();
  }, [location.search]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="p-6 rounded shadow-md bg-white text-black">
        <h2 className="text-xl font-semibold mb-4">Registration</h2>
        <p className={status === 'error' ? 'text-red-600' : status === 'success' ? 'text-green-600' : 'text-gray-700'}>{message}</p>
      </div>
    </div>
  );
};

export default RegisterFromLink;
 